import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;
    subscribeGridItem?: GridItemProps;
    socialLinksGridItem?: GridItemProps;
    siteMapLinksGridItem?: GridItemProps;
    richContentGridItem?: GridItemProps;
    logoWrapper?: InjectableCss;
}

export const footerContainerStyles: FooterContainerStyles = {
    widgetGridContainer: {
        css: css`
            background-color: #1b3358;
            margin: auto;
            div[class^="GridOffset"] {
                width: 100%;
                margin: 0px;
            }

            div[class^="LazyImageStyle"] {
                height: 50px;
                width: 70px;
                margin-top: 10px;
            }
            div[class="copyRightContainer"] {
                padding-top: 20px;
                padding-right: 10px;
            }
            div[class="policyContainer"] {
                padding-top: 20px;
                p {
                    a {
                        span {
                            color: rgb(150, 157, 172);
                            &:hover {
                                color: rgb(150, 157, 172);
                            }
                        }
                    }
                }
            }
        `,
    },
    linkList1GridItem: {
        width: [12, 12, 12, 6, 6],
        css: css`
            border-bottom: 1px solid #4165ac;
            color: #ffffff;
            div[class^="Wrapper"] {
                display: flex;
                align-items: center;
                > div[class^="sc"]:first-child {
                    width: 25%;
                    max-width: 25%;
                    flex-basis: 25%;
                    .wrapper {
                        flex-basis: unset;
                        padding-top: 0;
                    }
                }
                div {
                    flex-basis: 10%;
                    padding-top: 7px;
                }
                div[class^="ContentWrapper"] {
                    flex-basis: 26%;
                    padding-top: 20px;
                }
            }
            div[class^="Wrapper"] div[class^="LazyImageStyle"] {
                height: auto;
                width: auto;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        div[class^="Wrapper"] {
                            div {
                                flex-basis: 13%;
                            }
                            div[class^="ContentWrapper"] {
                                flex-basis: 50%;
                            }
                        }
                    `,
                    css`
                    null  
                `,
                    css`
                        div[class^="Wrapper"] {
                            justify-content: center;
                        }
                        div[class^="Wrapper"] {
                            div[class^="ContentWrapper"] {
                                flex-basis: 32%;
                            }
                            div {
                                flex-basis: 8%;
                            }
                        }
                    `,
                    css`
                   null
                `,
                    css`
                    null
                `,
                ])}
        `,
    },
    linkList2GridItem: {
        width: [12, 12, 12, 2, 2],
        css: css`
            border-bottom: 1px solid #4165ac;
            color: #ffffff;
            div[class^="ContentWrapper"] {
                p {
                    position: relative;
                    left: 140px;
                }
            }
        `,
    },
    subscribeGridItem: {
        width: [12, 12, 12, 6, 6],
        css: css`
            + div[class^="GridItemStyle"] {
                [class^="LazyImageStyle"] {
                    float: right;
                }
            }
            border-bottom: 1px solid #4165ac;
            div[class^="FormFieldStyle"] {
                margin-right: 0px;
            }
            h4 {
                font-size: 16px;
                color: #fff;
                margin-right: 10px;
            }
            button {
                color: #ffffff;
                background-color: #3465b1;
                border: 1px solid #3465b1;
                cursor: pointer;
                word-break: normal;
                &:hover {
                    border: 1px solid #0000ff;
                }
                span {
                    font-size: 14px;
                    font-weight: normal;
                }
            }
            input[type="text"] {
                color: #a7a7a7;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        div[class^="GridOffset"] {
                            [class^="GridItemStyle"]:nth-child(2) {
                                [class^="GridItemStyle"]:nth-child(1) {
                                    padding: 0px;
                                    flex-basis: 50%;
                                }
                            }
                        }
                        button {
                            padding-right: 10px;
                            padding-left: 10px;
                        }
                    `,
                    css`
                    null  
                `,
                    css`
                        h4 {
                            margin-right: 40px;
                        }
                        button {
                            position: relative;
                            right: 116px;
                        }
                    `,
                    css`
                   null
                `,
                    css`
                    null
                `,
                ])}
        `,
    },
    socialLinksGridItem: {
        width: 12,
        css: css``,
    },
    siteMapLinksGridItem: {
        width: 12,
    },
    richContentGridItem: {
        width: 12,
        css: css`
            > div[class^="Wrapper"] {
                > div[class^="GridWrapper"] {
                    > div[class^="GridOffset"] {
                        > div:first-child[class^="GridItemStyle"] {
                        }
                        > div:last-child[class^="GridItemStyle"] {
                        }
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            div[class="copyRightContainer"] {
                                p {
                                    text-align: center;
                                }
                            }
                            div[class="policyContainer"] {
                                p {
                                    text-align: center;
                                }
                            }
                            div[class^="GridOffset"] {
                                [class^="GridItemStyle"]:nth-child(2) {
                                    [class^="GridItemStyle"]:nth-child(2) {
                                        flex-basis: 60%;
                                        max-width: 60%;
                                    }
                                }
                            }
                        `,
                        css`
                            div[class="copyRightContainer"] {
                                p {
                                    text-align: center;
                                }
                            }
                            div[class="policyContainer"] {
                                p {
                                    text-align: center;
                                }
                            }
                        `,
                        css`
                            div[class="copyRightContainer"] {
                                p {
                                    text-align: left;
                                }
                            }
                        `,
                        css`
                            div[class="copyRightContainer"] {
                                p {
                                    text-align: left;
                                }
                            }
                        `,
                        css``,
                    ],
                    "minMax",
                )}
        `,
    },
    logoWrapper: {
        css: css`
            width: 110px;
        `,
    },
};

const FooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));
    return (
        <GridContainer {...styles.widgetGridContainer}>
            <GridItem {...styles.linkList1GridItem}>
                <Zone zoneName="LinkList1" contentId={id} />
            </GridItem>
            {/* <GridItem {...styles.linkList2GridItem}>
                <Zone zoneName="LinkList2" contentId={id} />
            </GridItem> */}
            <GridItem {...styles.subscribeGridItem}>
                <Zone zoneName="Subscribe" contentId={id} />
            </GridItem>
            <GridItem {...styles.richContentGridItem}>
                <Zone zoneName="RichContent" contentId={id} />
            </GridItem>
        </GridContainer>
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
    },
};

export default footerContainer;
